import styled from "@emotion/styled";
import { Dialog } from "@mui/material";
import { SmsRule } from "~/core/resources/smsApi";
import { ModalWrapper } from "~/modals/common/ModalWrapper";
import { ModalHeader } from "~/modals/common/ModalHeader";
import { ModalBody } from "~/modals/common/ModalBody";
import { ImmediateSmsPreviewTable } from "~/modals/ImmediateSmsPreviewTable";

const TableContent = styled("div")`
  overflow: auto;
  flex-shrink: 0;
`;

const TableWrapper = styled(TableContent)`
  height: 400px;
`;

const StyledDialog = styled(Dialog)`
  & .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.2) !important;
  }
  .MuiPaper-root {
    box-shadow: none;
    max-width: 1300px;
  }
`;

type ImmediateSmsPreviewModalProps = {
  appointment: any;
  smsRules: SmsRule[];
  onClose: () => void;
};

export const ImmediateSmsPreviewModal = ({
  appointment,
  smsRules,
  onClose,
}: ImmediateSmsPreviewModalProps) => {
  return (
    <StyledDialog open={true} onClose={onClose}>
      <ModalWrapper>
        <ModalHeader
          title="즉시 전송 문자 미리보기"
          onClose={() => onClose()}
        />
        <ModalBody>
          <TableWrapper>
            <ImmediateSmsPreviewTable
              appointment={appointment}
              smsRules={smsRules}
            />
          </TableWrapper>
        </ModalBody>
      </ModalWrapper>
    </StyledDialog>
  );
};
